<ion-header>
  <app-no-internet-connection></app-no-internet-connection>
  <app-ionic-update-error></app-ionic-update-error>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button routerLink="/homepage">
        <ion-icon name="chevron-back-outline"></ion-icon>
        <ion-text>{{ "back" | translate }}</ion-text>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ "upos-login.title" | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="uposLoginWrapper">
    <ion-grid class="uposLoginCard">
      <ion-row>
        <ion-col size="12">
          <ion-item>
            <ion-label position="stacked">
              {{ "upos-login.mobile" | translate }}
            </ion-label>
            <ion-input
              type="tel"
              [disabled]="loading || !groupReady"
              [(ngModel)]="mobile"
              (ngModelChange)="clearLoginError()"
              [placeholder]="'write-here-your-mobile' | translate"
              (keyup.enter)="submitLogin()"
            ></ion-input>
          </ion-item>
        </ion-col>

        <ion-col size="12">
          <ion-item>
            <ion-label position="stacked">
              {{ "popups.magic-login-confirmation.password" | translate }}
            </ion-label>
            <ion-input
              type="password"
              [disabled]="loading || !groupReady"
              [(ngModel)]="password"
              (ngModelChange)="clearLoginError()"
              [placeholder]="'write-here' | translate"
              (keyup.enter)="submitLogin()"
            ></ion-input>
          </ion-item>
        </ion-col>

        <ion-col size="12" *ngIf="loginError">
          <ion-text color="danger" class="uposLoginError">
            {{ loginError }}
          </ion-text>
        </ion-col>

        <ion-col size="12" *ngIf="!groupReady">
          <div class="uposLoginLoading">
            <ion-spinner></ion-spinner>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <div class="uposLoginFooter">
      <ion-button
        [disabled]="loading || !groupReady || !mobile || !password"
        (click)="submitLogin()"
      >
        <ion-spinner *ngIf="loading"></ion-spinner>
        <ion-text *ngIf="!loading">{{ "login" | translate }}</ion-text>
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
